import { useEffect, useState } from "react"
import { Link, Icon } from "@mobi/ds"
import If from "@mobi/components/If"
import IconChevronDown from "@mobi/ds/static/icons/outlined/seta-baixo.svg"

const DropdownMenuMobile = ({
  show,
  content,
  menuContent,
  openAccountLink = "/?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto",
  utmsHeaderMenuCheckingAccount,
  handleSubmenuOpenAccountLink,
}) => {
  const [showMenuAnimation, setShowMenuAnimation] = useState(false)

  useEffect(() => {
    if (show) {
      setShowMenuAnimation(true)
    } else {
      setShowMenuAnimation(false)
    }
  }, [show])

  const clickMenuSubTitle = (e) => {
    const activeClassName = "ds-header__menu-list-links--active"
    const titleClassName = "ds-header__menu-item--active"
    const clickedTarget = e.target.nextElementSibling
      ? e.target
      : e.target.closest(".ds-header__menu-item")

    const menuSubTitle = clickedTarget.nextElementSibling
    if (menuSubTitle.classList.contains(activeClassName)) {
      menuSubTitle.classList.remove(activeClassName)
      clickedTarget.classList.remove(titleClassName)
      clickedTarget.ariaExpanded = false
      menuSubTitle.ariaHidden = true
    } else {
      document
        .querySelector(`.${activeClassName}`)
        ?.classList?.remove(activeClassName)
      document
        .querySelector(`.ds-header__menu-item-submenu.${titleClassName}`)
        ?.classList.remove(titleClassName)
      menuSubTitle.classList.add(activeClassName)
      clickedTarget.classList.add(titleClassName)
      clickedTarget.ariaExpanded = true
      menuSubTitle.ariaHidden = false
    }
  }

  const showClassName =
    (showMenuAnimation && "ds-header__menu-list--submenu-active") || ""

  return (
    <>
      <ul
        className={`ds-header__menu-list ds-header__menu-list--submenu ${showClassName}`}
      >
        {content && content}
        {!content && (
          <>
            {menuContent?.column?.map(
              ({ link: contentItems, submenu_title: submenuTitle }, index) => (
                <li
                  className="menu-item-wrapper"
                  key={`menu-item-${submenuTitle}`}
                >
                  <button
                    className="ds-header__menu-item ds-header__menu-item-submenu"
                    onClick={clickMenuSubTitle}
                    aria-expanded="false"
                  >
                    {submenuTitle}
                    <IconChevronDown />
                  </button>
                  <ul className="ds-header__menu-list-links">
                    {contentItems?.map(
                      ({ link_properties: { title, href } }, index) => {
                        return (
                          <li
                            className="ds-header__menu-item-link"
                            key={`menu-item-link-${submenuTitle}-${href}-${index}`}
                          >
                            <If
                              condition={title === "conta-corrente"}
                              renderIf={
                                <Link
                                  onClick={handleSubmenuOpenAccountLink}
                                  href={`https://www.itau.com.br/contas/conta-corrente${openAccountLink}${utmsHeaderMenuCheckingAccount}`}
                                  alt="Link para conta corrente"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {title}
                                </Link>
                              }
                              renderElse={<Link href={href}>{title}</Link>}
                            />
                          </li>
                        )
                      }
                    )}
                  </ul>
                </li>
              )
            )}
            <li className="menu-item-wrapper">
              <button
                className="ds-header__menu-item ds-header__menu-item-submenu"
                onClick={clickMenuSubTitle}
              >
                {menuContent?.fancy_links?.submenu_title}
                <IconChevronDown />
              </button>
              <ul className="ds-header__menu-list-links">
                {menuContent?.fancy_links?.link?.map(
                  ({
                    link_properties: { href, title },
                    icon_selection: icon,
                  }) => {
                    const iconName = icon?.replace("icon-itaufonts_", "")
                    return (
                      <li
                        className={`ds-header__menu-item-link ${
                          (iconName && "ds-header__menu-item-link--icon") || ""
                        }`}
                        key={`menu-item-fancy-link-${title}`}
                      >
                        <Link href={href}>
                          <If
                            condition={iconName}
                            renderIf={<Icon icon={iconName} type="outlined" />}
                          ></If>
                          {title}
                        </Link>
                      </li>
                    )
                  }
                )}
              </ul>
            </li>
          </>
        )}
      </ul>
    </>
  )
}

export default DropdownMenuMobile
